module.exports = __webpack_public_path__ + "img/menu_ht_new.1d0c3100.png";